// extracted by mini-css-extract-plugin
module.exports = {"page":"EventList_page__-yJqq","mainTable":"EventList_mainTable__3KyUk"};